import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { cities, companyTypes } from "../../../../../common/constants";
import { CompaniesListing } from "../../../../../pages/api/company";
import Select from "../../../../components/Select/Select";

type FilterBoxProps = {
    companies: CompaniesListing[];
    setFilteredCompanies: Function;
    setActivePage: Function;
};

const FilterBox = ({
    setFilteredCompanies,
    setActivePage,
    companies,
}: FilterBoxProps) => {
    const [industry, setIndustry] = useState(null);
    const [city, setCity] = useState(null);
    const [name, setName] = useState(null);

    const router = useRouter();

    useEffect(() => {
        let filteredData = companies;
        if (industry?.value) {
            filteredData = filteredData.filter(
                (company) => company.type.slug === industry.value
            );
        }
        if (city?.value) {
            filteredData = filteredData.filter(
                (company) =>
                    company.citiesList.filter((cty) => cty.slug === city.value)
                        .length
            );
        }
        if (name) {
            filteredData = filteredData.filter((company) =>
                company.name.toLowerCase().startsWith(name.toLowerCase())
            );
            setActivePage(1);
        }
        setFilteredCompanies(filteredData);
    }, [industry, city, name]);

    const runSearch = () => {
        var url = new URL(`${window.location.origin}/kompanije/pretraga/`);
        if (city?.value) {
            url.searchParams.append("lokacija", city.value);
        }

        if (industry?.value) {
            url.searchParams.append("type", industry.value);
        }

        if (name) {
            url.searchParams.append("name", name);
        }

        router.push(url.href);
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 relative max-w-screen-lg m-auto mb-12 -mt-9 py-7 md:py-10 px-6 border job-shadow rounded-3xl bg-white border-gray-light">
            <div className="relative w-full my-2 md:my-0">
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    placeholder="Filtriraj po nazivu"
                    className="border border-gray text-gray-dark hover:border-blue rounded-full h-14 pl-6 pr-6 md:max-w-md w-full"
                />
                {/*                 
                <Select
                    options={companyTypes.map((cty) => ({
                        value: cty.slug,
                        label: cty.name,
                    }))}
                    value={industry}
                    placeholder="Industrija"
                    setValue={setIndustry}
                    type="industrija"
                    isMulti={false}
                /> */}
            </div>
            <div className="relative w-full my-2 md:my-0">
                <Select
                    isMulti={false}
                    options={cities.map((cty) => ({
                        value: cty.slug,
                        label: cty.name,
                    }))}
                    value={city}
                    placeholder="Lokacija"
                    setValue={setCity}
                    type="grad"
                />
            </div>
            <div className="relative w-full my-2 md:my-0">
                <button
                    type="button"
                    className="btn-primary relative w-full my-2 md:my-0 flex items-center justify-center"
                    onClick={runSearch}
                >
                    <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="md:hidden"
                    >
                        <path
                            d="M1 11.1521C1 13.8446 2.06959 16.4268 3.97348 18.3307C5.87736 20.2346 8.45958 21.3042 11.1521 21.3042C13.8446 21.3042 16.4268 20.2346 18.3307 18.3307C20.2346 16.4268 21.3042 13.8446 21.3042 11.1521C21.3042 8.45958 20.2346 5.87736 18.3307 3.97348C16.4268 2.06959 13.8446 1 11.1521 1C8.45958 1 5.87736 2.06959 3.97348 3.97348C2.06959 5.87736 1 8.45958 1 11.1521V11.1521Z"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M18.3301 18.33L23.2129 23.2128"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="inline-block mx-4">Filtriraj</span>
                </button>
            </div>
        </div>
    );
};

export default FilterBox;
